import { render, staticRenderFns } from "./u-dialog-flat-rounded.vue?vue&type=template&id=477e357e&scoped=true"
import script from "./u-dialog-flat-rounded.vue?vue&type=script&lang=js"
export * from "./u-dialog-flat-rounded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477e357e",
  null
  
)

export default component.exports